export default __webpack_public_path__ + "static/media/casper-dash.66ac4a2e.png";